import React, { Fragment, useContext, useEffect, useState } from "react";
import BoxTitle from "../../box/title/BoxTitle";
import BoxSubTitle from "../../box/subTitle/BoxSubTitle";
import { LoadingDot } from "../../UI/spinners/LoadingSpinners";
import { useAllContexts } from "../../../hooks/useAllContexts";

const UvIndexes = ({ indexName, typeId }) => {
  const { indexes } = useAllContexts();
  const { IndexesData, loading } = indexes;
  const [data, setData] = useState(null);

  useEffect(() => {
    if (IndexesData) {
      const tempData = IndexesData.filter(
        (item) => item.index_name === indexName
      )[0];
      setData(tempData);
    }
  }, [IndexesData]);

  return (
    <>
      {!loading ? (
        <>
          <BoxTitle
            icon={"im im-icon-Envelope-2"}
            title={data?.index_name}
            styleIcon={typeId === "5" && { color: "black" }}
            link={`/map?typeId=${typeId}`}
            infoContext={data?.tooltip}
            element={
              <i
                id="draggable"
                className="im im-icon-Double-Tap"
                style={{
                  fontSize: "32px",
                  minWidth: "32px",
                  cursor: "pointer",
                }}
              />
            }
            id={typeId}
          />
          {data && (
            <>
              <BoxSubTitle style={typeId === "5" ? { color: "white" } : {}}>
                <strong>
                  <span>
                    {`Τιμή δείκτη `} :{" "}
                    {parseFloat(data?.details[0].measurement)}
                    &nbsp;|&nbsp;
                  </span>

                  {data?.details[0].index_title}
                </strong>
              </BoxSubTitle>
              <p style={{ fontSize: "14px", lineHeight: "1.5em" }}>
                {data?.details[0].index_description}
              </p>
            </>
          )}
          {!data && (
            <p
              style={{
                fontWeight: "600",
                fontSize: "14px",
                paddingTop: "10px",
                color: "#333",
              }}
            >
              Αδυναμία λήψης δεδομένων λόγω προβλήματος
            </p>
          )}
        </>
      ) : (
        <LoadingDot />
      )}
    </>
  );
};

export default UvIndexes;
